<div class="{{localService.selectedLanguageCode}}"  *ngIf="localService.languageContent && localService.languageContent.table">
  <div class="banner center" style="max-width:800px;" *ngIf="wrappers">
    <div class="row row_header">
      <div class="col-1">
        {{localService.languageContent.table.action}}
      </div>
      <div class="col-6">
        {{localService.languageContent.table.title}}
      </div>
      <div class="col-5">
        {{localService.languageContent.table.type}}
        <div class="icon_action_header">
          <i class="material-icons on_language_changed" style="float:left;" (click)="onLoad()">replay_circle_filled</i>
          <i class="material-icons" style="float:left;" (click)="openCreateEditPopup('')" title="{{localService.languageContent.common.add}}">note_add</i>
        </div>
      </div>
    </div>
    <div class="row styled_row" *ngFor="let item of wrappers">
      <div class="col-1">
        <i class="material-icons button icon_adjust" title="{{item.v2 == '1' ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}" (click)="onActiveInactiveStatus(item.key)" [ngStyle]="{'color': item.v2 == '1' ? 'yellowgreen' : 'orangered' }">{{item.v2 == '1' ? "toggle_on" : "toggle_off"}}</i>
      </div>
      <div class="col-6">
        <span class="button" (click)="openCreateEditPopup(item.key)">{{item.v3}}</span>
      </div>
      <div class="col-5">
        {{getTypeName(item.v1)}}
      </div>
    </div>
  </div>
</div>
